module.exports = __webpack_public_path__ + "img/i_ar_main_sec_gr.5d50e2bd.svg";